import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Link, withRouter } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import AdminTopbarMenu from './AdminTopbarMenu';
import { Button, Link as MaterialLink } from '@material-ui/core';
import Menu from './AdminMenu';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from '../aws-exports';
import 'react-slidedown/lib/slidedown.css';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HomeIcon from '@material-ui/icons/Home';
import axiosInstance, { EVENT_CODE, EVENT_ID, getEventId, tokenRefresh, WEB_API } from '../constatns';
import jwt from 'jsonwebtoken';
import moment from 'moment-timezone';
import swal from '@sweetalert/with-react';
Amplify.configure(awsconfig);

const styles = (theme) => ({
  header: {
    position: 'relative',
    marginBottom: '0px',
  },
  appBar: {
    position: 'relative',
    boxShadow: 'none',
  },
  toolBar: {
    width: '100%',
    height: '100%',
    '& .MuiTabs-root': {
      height: '100%',
    },
    '& .MuiTabs-scroller': {
      display: 'flex',
    },
    [theme.breakpoints.down('sm')]: {
      paddingRight: '0px',
    },
  },
  inline: {
    display: 'inline',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      paddingTop: '0.5em',
    },
  },
  logo: {
    padding: '20px',
    width: 'auto',
  },
  iconContainer: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  iconButton: {
    float: 'right',
  },
  tabContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tabs: {
    background: theme.palette.secondary.main,
  },
  tabItem: {
    textTransform: 'none',
    paddingTop: 20,
    paddingBottom: 20,
    minWidth: 200,
    minHeight: 60,
    fontSize: '1rem',
    color: '#ffffff',
    fontWeight: 'bold',
    [theme.breakpoints.down('md')]: {
      minWidth: 140,
    },
    '&$selected': {
      backgroundColor: '#004C9B',
      color: 'white',
    },
  },
  menus: {
    listStyle: 'none',
    '& li': {
      display: 'inline-block',
      marginLeft: '10px',
    },
  },
  drawer: {
    backgroundColor: 'rgba(28,30,59,.90)',
    color: '#adbecc',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  drawerMenus: {
    '& ul': {
      listStyle: 'none',
      padding: 0,
      minWidth: '200px',
      '& li': {
        cursor: 'pointer',
        lineHeight: '2.8em',
        fontSize: '1.1em',
        textAlign: 'center',
        '&:hover': {
          color: '#ffffff',
        },
      },
    },
  },
  breadcrumbs: {
    position: 'absolute',
    height: 60,
    backgroundColor: theme.palette.primary.main,
    top: 390,
    width: 1200,
    color: '#ffffff',
  },
  crumbs: {
    '&:first-child': {
      cursor: 'pointer',
    },
    '&:last-child': {
      cursor: 'pointer',
    },
    '&:not(:first-child)': {
      minWidth: 200,
    },
    borderRight: '1px solid #ffffff',
    '& .MuiPaper-root': {
      width: 200,
      maxWidth: 200,
      borderRadius: 0,
      marginTop: 14,
      marginLeft: 5,
      '& li': {
        fontSize: '0.9em',
      },
    },
  },
  detailCardRoot: {
    width: '100%',
    top: '10px',
    marginTop: '2.5%',
    padding: '10px 15px 0px 15px',
    margin: 'auto',
    textAlign: 'center',
    position: 'absolute',
  },
});

class AdminTopbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      menuDrawer: false,
      username: '',
      mainSocket: null,
      show: false,
      submenuOpen: false,
      anchorEl: null,
    };
    this.logout = this.logout.bind(this);
    this.showMenus = this.showMenus.bind(this);
    this.hideMenus = this.hideMenus.bind(this);
    this.socketManager = this.socketManager.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  mobileMenuOpen = (event) => {
    this.setState({ menuDrawer: true });
  };

  mobileMenuClose = (event) => {
    this.setState({ menuDrawer: false });
  };

  handleToggle = () => {
    this.setState({ submenuOpen: !this.state.submenuOpen });
  };

  handleClose = (event) => {
    if (this.myRef.current && this.myRef.current.contains(event.target)) {
      return;
    }
    this.setState({ submenuOpen: false });
  };

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    Auth.signOut().then(() => {
      this.props.history.push('/');
    });
  }

  componentDidMount() {
    try {
      if (sessionStorage.getItem('_in_user_')) {
        if (sessionStorage.getItem('_in_role') !== 'SCRL_MGR') {
          this.props.history.push('/main');
          swal('관리자 전용페이지입니다.', { icon: 'warning' });
          return;
        } else {
          this.setState({
            username: sessionStorage.getItem('_in_user_').replace(EVENT_ID + '_', ''),
          });
        }
      } else {
        this.props.history.push('/signin');
      }
    } catch (e) {
      console.error(e);
    }
    // check token expire
    const decoded = jwt.decode(sessionStorage.getItem('_in_jwt'));
    if (decoded) {
      console.log(
        'tokenExp',
        moment(decoded.exp * 1000)
          .tz('Asia/Seoul')
          .format('YYYY-MM-DD HH:mm:ss'),
      );
      const exp = moment(decoded.exp * 1000);
      const now = moment();
      const diff = exp.diff(now, 'minutes');
      console.log(`토근 만료까지 ${diff}분 남았습니다.`);
      if (diff < 10) tokenRefresh().then((r) => {});
    }

    const EVT = JSON.parse(sessionStorage.getItem('EVENT'));
    if (!EVT) {
      axiosInstance
        .get(`${WEB_API}/event/info?eventId=${getEventId()}&code=${encodeURIComponent(EVENT_CODE)}`, {
          headers: { Pragma: 'no-cache' },
        })
        .then((response) => {
          if (response.data.Item) {
            sessionStorage.setItem('EVENT_ID', getEventId());
            sessionStorage.setItem('EVENT', JSON.stringify(response.data.Item));
          }
        });
    }

    window.scrollTo(0, 0);
    this.socketManager();
  }

  componentWillUnmount() {
    if (this.state.mainSocket) {
      this.state.mainSocket.close();
      delete this.state.mainSocket;
      this.setState({ mainSocket: null });
    }
  }

  socketManager() {
    console.log('>>> socketManger <<<');
  }

  current = () => {
    return this.props.MIdx;
  };

  showMenus() {
    this.setState({ show: true });
  }

  hideMenus() {
    this.setState({ anchorEl: null });
  }

  topicFilterOpen(e) {
    this.setState({ anchorEl: e.currentTarget });
  }

  list = () => {
    return (
      <Grid container justifyContent={'center'} spacing={0} className={this.props.classes.drawerMenus}>
        {Menu.map((item, index) => {
          return (
            <ul key={item.path}>
              {item.children.map((menu) => (
                <li key={menu.path}>{menu.label}</li>
              ))}
            </ul>
          );
        })}
      </Grid>
    );
  };

  render() {
    const { classes, history } = this.props;

    return (
      <div className={classes.header}>
        <AppBar position="static" color="default" className={classes.appBar}>
          <Toolbar className={classes.toolBar}>
            <Grid container spacing={4} justifyContent="center" alignItems={'center'}>
              <Grid item>
                <Link to="/admin" className={classes.link}>
                  <img src="/images/PRS2021/prs2021_logo.png" alt="" className={classes.logo} style={{ width: '350px' }} />
                </Link>
              </Grid>
              {/*<Grid item>*/}
              {/*  <div*/}
              {/*    style={window.matchMedia('(max-width:600px)').matches ? { display: 'none' } : { fontSize: '0.9em', fontWeight: 'bold' }}*/}
              {/*  >*/}
              {/*    <ul className={classes.menus}>*/}
              {/*      <li>HOME</li>*/}
              {/*      <li>|&nbsp;&nbsp;LOGOUT</li>*/}
              {/*      <li>|&nbsp;&nbsp;MY PAGE</li>*/}
              {/*    </ul>*/}
              {/*  </div>*/}
              {/*</Grid>*/}
            </Grid>
            <div
              style={{
                position: 'absolute',
                fontSize: '0.9em',
                fontWeight: 'bold',
                right: '150px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
              }}
            >
              <Grid container spacing={1} justifyContent={'flex-end'}>
                <Grid item>접속계정: {this.state.username}</Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item>
                  <Button variant="outlined" color="primary" size="small" startIcon={<HomeIcon />} onClick={() => history.push('/')}>
                    PRS2022
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="outlined" color="primary" size="small" startIcon={<ExitToAppIcon />} onClick={() => this.logout()}>
                    LOGOUT
                  </Button>
                </Grid>
              </Grid>
            </div>
            {/*<Grid*/}
            {/*  container*/}
            {/*  xs={3}*/}
            {/*  style={window.matchMedia('(max-width:960px)').matches ? { display: 'flex', justifyContent: 'flex-end' } : { display: 'flex' }}*/}
            {/*>*/}
            {/*  /!* 모바일 메뉴버튼 위치 변경               *!/*/}
            {/*  <div className={classes.iconContainer}>*/}
            {/*    <IconButton onClick={this.mobileMenuOpen} className={classes.iconButton} color="inherit" aria-label="Menu">*/}
            {/*      <MenuIcon />*/}
            {/*    </IconButton>*/}
            {/*  </div>*/}
            {/*</Grid>*/}
          </Toolbar>
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12}>
              {!this.props.noTabs && (
                <React.Fragment>
                  <div className={classes.tabContainer}>
                    <SwipeableDrawer
                      anchor="right"
                      open={this.state.menuDrawer}
                      onClose={this.mobileMenuClose}
                      onOpen={this.mobileMenuOpen}
                      style={{ width: '60%' }}
                    >
                      <AppBar title="Menu" />
                      <List>
                        {Menu.map((item, index) => (
                          <ListItem
                            component={item.external ? MaterialLink : Link}
                            href={item.external ? item.pathname : null}
                            to={
                              item.external
                                ? null
                                : {
                                    pathname: item.pathname,
                                    search: this.props.location.search,
                                  }
                            }
                            button
                            key={item.label}
                          >
                            <ListItemText primary={item.label} />
                          </ListItem>
                        ))}
                      </List>
                    </SwipeableDrawer>

                    <Tabs
                      value={this.current() || this.state.value}
                      indicatorColor="secondary"
                      onChange={this.handleChange}
                      centered
                      className={classes.tabs}
                    >
                      {Menu.map((item, index) => (
                        <Tab
                          component={item.external ? MaterialLink : Link}
                          href={item.external ? item.pathname : null}
                          to={
                            item.external
                              ? null
                              : {
                                  pathname: item.pathname,
                                  search: this.props.location.search,
                                }
                          }
                          classes={{ root: classes.tabItem }}
                          label={item.label}
                          onMouseOver={(e) => {
                            if (item.label === 'Status') {
                              this.topicFilterOpen(e);
                            }
                          }}
                          key={`admin-topbar-menu-${index}`}
                        />
                      ))}
                    </Tabs>
                    <AdminTopbarMenu anchorEl={this.state.anchorEl} onClose={this.hideMenus} />
                  </div>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
        </AppBar>
      </div>
    );
  }
}

export default withRouter(withStyles(styles, { withTheme: true })(AdminTopbar));
